import { i18n } from "@lingui/core";
import { button } from "@warp-ds/css/component-classes";
import WarpElement from "@warp-ds/elements-core";
import "@warp-ds/elements/components/card";
import { css, html } from "lit";
import { trackClickEvent } from "../tracking.js";
import { Brand, Subvertical } from "../../constants.js";
import { TrackingEventMap, eventReference } from "../../models/trackingEvent.js";
import { activateI18n } from "../../utils/i18n.js";

class SellMobilityVehicle extends WarpElement {
    declare brand: Brand;
    declare subvertical: Subvertical;
    declare trackingEventMap: TrackingEventMap;
    declare wrapperClass: string;

    static properties = {
        brand: { attribute: true, type: Brand },
        baseurl: { attribute: true, type: String },
        subvertical: { attribute: true, type: Subvertical },
        trackingEventMap: { type: Object },
        wrapperClass: { type: String },
    };
    static styles = [
        WarpElement.styles,
        css`
            @css-placeholder-Smjmr9;
        `,
    ];

    constructor() {
        super();
    }

    connectedCallback() {
        activateI18n();
        super.connectedCallback();
    }

    get newAdUrl() {
        switch (this.subvertical) {
            case Subvertical.Car:
                return "/create-item/start/car";
            case Subvertical.B2B:
                return "/create-item/start/agriculture";
            case Subvertical.Boat:
                return "/create-item/start/boat";
            case Subvertical.Mc:
                return "/create-item/start/mc";
        }
    }

    render() {
        const newAdUrl = this.newAdUrl;
        const nettbilUrl = `https://nettbil.no/finn?origin=car_browse`;

        const newAd = i18n.t({
            id: "market-frontpage.new-ad",
            message: "New ad",
        });

        const nettbil = i18n.t({
            id: "market-frontpage.nettbil",
            message: "Sell using Nettbil",
        });

        const wheelaway = i18n.t({
            id: "market-frontpage.wheelaway",
            message: "Sell using Wheelaway",
        });

        const showExternalLink = this.brand === Brand.FINN && this.subvertical === Subvertical.Car;

        const externalLinkData = {
            url: this.brand === Brand.FINN ? nettbilUrl : "https://wheelaway.se",
            label: this.brand === Brand.FINN ? nettbil : wheelaway,
            evtReference: eventReference.DEALER,
        };

        return html`
            <div class="${this.wrapperClass || "space-x-12"}">
                ${showExternalLink
                    ? html`<a
                          data-tracking-id=${this.brand === Brand.FINN ? "nettbil" : "wheelaway"}
                          @click=${() => trackClickEvent(this.trackingEventMap[externalLinkData.evtReference], externalLinkData.url)}
                          href=${externalLinkData.url}
                          class="${button.secondary} inline-flex px-16 items-center font-bold text-12 flex-1 hover:no-underline py-6"
                      >
                          ${externalLinkData.label}
                      </a>`
                    : ""}
                <a
                    data-tracking-id="new-ad"
                    @click=${() => trackClickEvent(this.trackingEventMap[eventReference.NEW_AD], newAdUrl)}
                    href=${newAdUrl}
                    class="${button.primary} inline-flex px-16 font-bold items-center text-12 flex-1 hover:no-underline py-6 border-2 s-border-primary hover:s-border-primary-hover"
                >
                    ${newAd}
                </a>
            </div>
        `;
    }
}

customElements.define("mfp-sell-mobility-vehicle", SellMobilityVehicle as unknown as CustomElementConstructor);
